/* La Fleur by ShaniZimmerman — Theme JS */
/* Adapted from index.html for Shopify */

document.addEventListener('DOMContentLoaded', function () {

  // ── LIVE EXCHANGE RATE (ILS → USD) ──
  async function updateExchangeRate() {
    try {
      const res = await fetch('https://api.frankfurter.app/latest?from=ILS&to=USD');
      const data = await res.json();
      const rate = data.rates.USD;
      document.querySelectorAll('.product-price-usd[data-ils]').forEach(el => {
        const ils = parseFloat(el.dataset.ils);
        const usd = (ils * rate).toFixed(0);
        el.textContent = `$${Number(usd).toLocaleString()}`;
      });
    } catch (e) {
      document.querySelectorAll('.product-price-usd').forEach(el => el.style.display = 'none');
    }
  }
  updateExchangeRate();

  // ── SIZE SELECTOR TOGGLE ──
  document.querySelectorAll('.sizes-row').forEach(row => {
    row.querySelectorAll('.size-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        row.querySelectorAll('.size-btn').forEach(b => {
          b.classList.remove('active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('active');
        btn.setAttribute('aria-pressed', 'true');
      });
    });
  });

  // ── HAMBURGER MENU ──
  const menuToggle  = document.getElementById('menu-toggle');
  const mobileNav   = document.getElementById('mobile-nav');
  const mobileClose = document.getElementById('mobile-nav-close');

  function openMenu() {
    mobileNav.classList.add('open');
    mobileNav.setAttribute('aria-hidden', 'false');
    menuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    mobileNav.classList.remove('open');
    mobileNav.setAttribute('aria-hidden', 'true');
    menuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  menuToggle?.addEventListener('click', openMenu);
  mobileClose?.addEventListener('click', closeMenu);
  mobileNav?.querySelectorAll('.mobile-nav-link').forEach(a => a.addEventListener('click', closeMenu));

  // ── PRODUCT IMAGE GALLERY (dots + swipe) ──
  document.querySelectorAll('.product-img').forEach(container => {
    const slides = container.querySelectorAll('.gallery-slide');
    const dots   = container.querySelectorAll('.gdot');
    if (!slides.length) return;

    function goTo(i) {
      slides.forEach(s => {
        s.classList.remove('active');
        if (s.tagName === 'VIDEO') { s.pause(); s.currentTime = 0; }
      });
      dots.forEach(d => d.classList.remove('active'));
      slides[i].classList.add('active');
      if (dots[i]) dots[i].classList.add('active');
      if (slides[i].tagName === 'VIDEO') slides[i].play();
    }

    function current() {
      return [...slides].findIndex(s => s.classList.contains('active'));
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', e => { e.stopPropagation(); goTo(i); });
    });

    let startX = 0;
    container.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    container.addEventListener('touchend', e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) < 40) return;
      const idx = current();
      if (diff > 0 && idx < slides.length - 1) goTo(idx + 1);
      if (diff < 0 && idx > 0) goTo(idx - 1);
    }, { passive: true });
  });

  // ── ACCORDION TOGGLE ──
  document.querySelectorAll('.accordion-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!isOpen));
      btn.nextElementSibling.classList.toggle('open', !isOpen);
    });
  });

  // ── ADD TO CART (Shopify AJAX Cart API) ──
  function updateCartCount(count) {
    document.querySelectorAll('.cart-btn').forEach(btn => {
      btn.textContent = `Bag (${count})`;
      btn.setAttribute('aria-label', `Shopping cart (${count} items)`);
    });
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = count;
    });
  }

  function addToCart(variantId, quantity, btn) {
    if (!variantId) {
      alert('Please select a size first.');
      return;
    }

    btn.textContent = '...';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
    .then(response => {
      if (!response.ok) throw new Error('Could not add to cart');
      return fetch('/cart.js');
    })
    .then(r => r.json())
    .then(cart => {
     btn.textContent = '✓ Added';
      btn.classList.add('added');
      updateCartCount(cart.item_count);
      setTimeout(() => {
      btn.textContent = 'Add to Bag';
        btn.classList.remove('added');
        btn.disabled = false;
      }, 2000);
    })
    .catch(err => {
      console.error('Cart error:', err);
     btn.textContent = 'Add to Bag';
      btn.disabled = false;
      alert('Could not add to cart. Please try again.');
    });
  }

  // Bind add-to-cart buttons (for product cards with data-variant-id)
  document.querySelectorAll('.btn-add-cart').forEach(btn => {
    btn.addEventListener('click', function () {
      const card = this.closest('.product-card, .product-form, form[action="/cart/add"]');
      let variantId = null;

      // Check for a selected variant input
  const variantInput = card?.querySelector('[name="id"]');
      if (variantInput) {
        variantId = variantInput.value;
      }

      // Or check for a selected size button with data-variant-id
      const activeSize = card?.querySelector('.size-btn.active[data-variant-id]');
      if (activeSize) {
        variantId = activeSize.dataset.variantId;
      }

      // Fallback: data-variant-id on the button itself
      if (!variantId) {
        variantId = this.dataset.variantId;
      }

      addToCart(variantId, 1, this);
    });
  });

  // ── PRODUCT FORM SUBMIT (product page) ──
  document.querySelectorAll('form.product-form').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const variantInput = this.querySelector('[name="id"]');
      const variantId = variantInput?.value;
      const btn = this.querySelector('[type="submit"]');
      addToCart(variantId, 1, btn);
    });
  });

  // ── LIFE IN LA FLEUR AUTO-SLIDESHOW ──
  (function () {
    const slides = document.querySelectorAll('.life-slide');
    const dots   = document.querySelectorAll('.life-dot');
    if (!slides.length) return;
    let cur = 0, timer;

    function goTo(i) {
      slides[cur].classList.remove('active');
      if (dots[cur]) dots[cur].classList.remove('active');
      cur = (i + slides.length) % slides.length;
      slides[cur].classList.add('active');
      if (dots[cur]) dots[cur].classList.add('active');
    }

    function next() { goTo(cur + 1); }

    dots.forEach((dot, i) => dot.addEventListener('click', () => {
      clearInterval(timer);
      goTo(i);
      timer = setInterval(next, 5000);
    }));

    timer = setInterval(next, 5000);
  })();

  // ── ACCESSIBILITY WIDGET ──
  (function () {
    let fontSize = 100;

    const toggle   = document.getElementById('a11y-toggle');
    const panel    = document.getElementById('a11y-panel');
    const closeBtn = document.getElementById('a11y-close');
    const body     = document.body;

    toggle?.addEventListener('click', () => {
      const isOpen = panel.classList.contains('open');
      panel.classList.toggle('open', !isOpen);
      toggle.setAttribute('aria-expanded', String(!isOpen));
      if (!isOpen) closeBtn?.focus();
    });

    closeBtn?.addEventListener('click', () => {
      panel.classList.remove('open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle?.focus();
    });

    document.addEventListener('click', e => {
      if (!e.target.closest('.a11y-widget')) {
        panel?.classList.remove('open');
        toggle?.setAttribute('aria-expanded', 'false');
      }
    });

    document.getElementById('a11y-contrast')?.addEventListener('click', function () {
      const on = body.getAttribute('data-a11y-contrast') === 'high';
      body.setAttribute('data-a11y-contrast', on ? '' : 'high');
      this.classList.toggle('active', !on);
      this.setAttribute('aria-pressed', String(!on));
    });

    document.getElementById('a11y-grayscale')?.addEventListener('click', function () {
      const on = body.getAttribute('data-a11y-grayscale') === 'on';
      body.setAttribute('data-a11y-grayscale', on ? '' : 'on');
      this.classList.toggle('active', !on);
      this.setAttribute('aria-pressed', String(!on));
    });

    document.getElementById('a11y-links')?.addEventListener('click', function () {
      const on = body.getAttribute('data-a11y-links') === 'on';
      body.setAttribute('data-a11y-links', on ? '' : 'on');
      this.classList.toggle('active', !on);
      this.setAttribute('aria-pressed', String(!on));
    });

    document.getElementById('a11y-font-readable')?.addEventListener('click', function () {
      const on = body.getAttribute('data-a11y-font') === 'readable';
      body.setAttribute('data-a11y-font', on ? '' : 'readable');
      this.classList.toggle('active', !on);
      this.setAttribute('aria-pressed', String(!on));
    });

    document.getElementById('a11y-font-increase')?.addEventListener('click', () => {
      if (fontSize >= 140) return;
      fontSize += 10;
      document.documentElement.style.fontSize = fontSize + '%';
    });

    document.getElementById('a11y-font-decrease')?.addEventListener('click', () => {
      if (fontSize <= 80) return;
      fontSize -= 10;
      document.documentElement.style.fontSize = fontSize + '%';
    });

    document.getElementById('a11y-reset')?.addEventListener('click', () => {
      fontSize = 100;
      document.documentElement.style.fontSize = '';
      body.removeAttribute('data-a11y-contrast');
      body.removeAttribute('data-a11y-grayscale');
      body.removeAttribute('data-a11y-links');
      body.removeAttribute('data-a11y-font');
      document.querySelectorAll('.a11y-btn').forEach(b => {
        b.classList.remove('active');
        b.setAttribute('aria-pressed', 'false');
      });
    });
  })();

  // ── NEWSLETTER FORM ──
  document.querySelector('.nl-form')?.addEventListener('submit', e => {
    e.preventDefault();
    const btn   = e.target.querySelector('button');
    const input = e.target.querySelector('input');
    btn.textContent = '✓ Subscribed!';
    btn.style.background = '#4AA8A8';
    input.value = '';
    setTimeout(() => {
      btn.textContent = 'Subscribe';
      btn.style.background = '';
    }, 3000);
  });

  // ── KEYBOARD ACCESSIBILITY FOR COLLECTION CARDS ──
  document.querySelectorAll('.col-card[role="button"]').forEach(card => {
    card.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        card.querySelector('.col-card-link')?.click();
      }
    });
  });

  // ── PRODUCT PAGE GALLERY (full page) ──
  const mainImg = document.querySelector('.gallery-main img');
  if (mainImg) {
    document.querySelectorAll('.product-page-thumbnails img').forEach(thumb => {
      thumb.addEventListener('click', function () {
        mainImg.src = this.src;
        mainImg.alt = this.alt;
        document.querySelectorAll('.product-page-thumbnails img').forEach(t => t.classList.remove('active'));
        this.classList.add('active');
      });
    });
  }

  // ── CART PAGE: REMOVE ITEM ──
  document.querySelectorAll('.cart-item-remove').forEach(btn => {
    btn.addEventListener('click', function () {
      const key = this.dataset.key;
      if (!key) return;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
      .then(r => r.json())
      .then(cart => {
        updateCartCount(cart.item_count);
        // Remove the item row from DOM
        this.closest('.cart-item')?.remove();
        // Reload if cart empty
        if (cart.item_count === 0) location.reload();
      });
    });
  });

  // ── INIT: fetch cart count on load ──
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => updateCartCount(cart.item_count))
    .catch(() => {});

});
// Nav dropdown
document.querySelectorAll('.nav-dropdown').forEach(function(dd) {
  var menu = dd.querySelector('.nav-dropdown-menu');
  var timer;
  dd.addEventListener('mouseenter', function() {
    clearTimeout(timer);
    menu.style.display = 'flex';
  });
  dd.addEventListener('mouseleave', function() {
    timer = setTimeout(function() { menu.style.display = ''; }, 150);
  });
});